import React from 'react';

/**
 * Skeleton placeholders for content whose shape is known — use these for
 * page/section data loads instead of spinner overlays. Keep spinners for
 * button-level actions.
 *
 * <Skeleton className="h-4 w-32" />           — single block
 * <SkeletonText lines={3} />                  — paragraph of shimmering lines
 * <SkeletonRows rows={5} />                   — list/table rows (orders, results)
 * <SkeletonCard />                            — dashboard stat card
 */
export function Skeleton({ className = '' }) {
  return <div className={`animate-pulse rounded bg-gray-200 ${className}`} aria-hidden="true" />;
}

export function SkeletonText({ lines = 3, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={`h-4 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  );
}

export function SkeletonRows({ rows = 5, className = '' }) {
  return (
    <div className={`space-y-3 ${className}`} role="status" aria-label="Loading content">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="bg-white rounded-lg border border-gray-200 p-4 flex items-center justify-between animate-pulse">
          <div className="flex-1 space-y-2">
            <div className="h-4 w-1/3 rounded bg-gray-200" />
            <div className="h-3 w-1/2 rounded bg-gray-100" />
          </div>
          <div className="h-6 w-20 rounded-full bg-gray-200" />
        </div>
      ))}
      <span className="sr-only">Loading…</span>
    </div>
  );
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 animate-pulse ${className}`} aria-hidden="true">
      <div className="h-4 w-1/3 rounded bg-gray-200 mb-4" />
      <div className="h-8 w-1/2 rounded bg-gray-200 mb-2" />
      <div className="h-3 w-2/3 rounded bg-gray-100" />
    </div>
  );
}

export default Skeleton;
